import { render } from "./VoiceRecorder.vue?vue&type=template&id=028aa330&scoped=true"
import script from "./VoiceRecorder.vue?vue&type=script&lang=js"
export * from "./VoiceRecorder.vue?vue&type=script&lang=js"

import "./VoiceRecorder.vue?vue&type=style&index=0&id=028aa330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028aa330"]])

export default __exports__